<script>
import { useAlert } from 'dashboard/composables';
import ScriptTemplate from './ScriptTemplate.vue'


export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    buttonLabel: {
      type: String,
      default: '',
    },
    buttonIcon: {
      type: String,
      default: 'edit',
    },
    priceId: {
      type: String,
      default: '',
    },
    gptChatEnabled: {
      type: Boolean,
      default: false,
    },
    merchant: {
      type: Object,
      default: null,
    },
    imageUrl: {
      type: String,
      default: '',
    },
    errorDesc: {
      type: String,
      default: '',
    },
    isTest: {
      type: Boolean,
      default: false,
    },
    onOpen: {
      type: Function,
      default: () => { },
    },
    testChat: {
      type: Boolean,
      default: false
    },
    isDot: {
      type: Boolean,
      default: false
    }
  },
  components: { ScriptTemplate },
  emits: ['open'],
  data() {
    return {
      isChatwootOpen: false, // 用于防止重复关闭
      emptyScriptText: this.$t(
        'BILLING_SETTINGS.MANAGE_SUBSCRIPTION.SCRIPT_EMPTY'
      ),
      showAddPopup: false,
      fileList: [],
      docTitle: "",
    };
  },
  computed: {
    usedFileExtension() {
      return this?.merchant?.usedFileUrlList?.length > 0
        ? this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.MERCHANT_SCRIPT_DETAIL')
        : this.emptyScriptText;
    },
    shopFileExtension() {
      return this?.merchant?.fileUrlList?.length > 0
        ? this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.MERCHANT_SCRIPT_DETAIL')
        : this.emptyScriptText;
    },
    approvedFileExtension() {
      return this?.merchant?.approvedFileUrlList?.length > 0
        ? this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.MERCHANT_SCRIPT_DETAIL')
        : this.emptyScriptText;
    },
    isCompare() {
      return this.areFileURLListsEqualIgnoreOrder(
        this?.merchant?.fileUrlList || [],
        this?.merchant?.usedFileUrlList || []
      );
    },
    isApprovalCompare() {
      const result = this?.merchant?.reviewStatus === 'processing' && !this.areFileURLListsEqualIgnoreOrder(
        this?.merchant?.fileUrlList || [],
        this?.merchant?.approvedFileUrlList || []
      );
    
      console.info(result, "===============result====================")
      return result
    },
    isRelease() {
      let isCompare = this.areFileURLListsEqualIgnoreOrder(
        this?.merchant?.fileUrlList || [],
        this?.merchant?.approvedFileUrlList || []
      );
      return this.isDot && isCompare && this?.merchant?.reviewStatus === 'processing'
    }
  },
  methods: {
    openAddPopup() {
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.showAddPopup = false;
    },
    isHighlight(text) {
      return text !== this.emptyScriptText;
    },
    areFileURLListsEqualIgnoreOrder(existingList, incomingList) {
      if (existingList.length !== incomingList.length) {
        return false;
      }

      const countMap = new Map();

      for (const item of existingList) {
        countMap.set(item, (countMap.get(item) || 0) + 1);
      }

      for (const item of incomingList) {
        if (!countMap.has(item)) {
          return false;
        }
        countMap.set(item, countMap.get(item) - 1);
        if (countMap.get(item) === 0) {
          countMap.delete(item);
        }
      }

      return countMap.size === 0;
    },
    handleButtonClick() {
      // 如果 title 是 "customer"，加载 Chatwoot
      if (this.testChat) {
        if (this.isTest) {
          let result = this.onOpen();
          console.info('result: ', result);
          if (result) {
            return;
          }
        }

        if (this.imageUrl) {
          this.$store.dispatch('accounts/toggleIframeVisible');
          return;
        }
        const checkButtonInterval = setInterval(() => {
          console.info(
            this.gptChatEnabled,
            '======this.gptChatEnabled======',
            this.imageUrl
          );
          if (!this.gptChatEnabled) {
            clearInterval(checkButtonInterval); // 清除定时器
            // 报错提示
            useAlert(
              this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TEST_PROMPT_ERROR')
            );
            return;
          }
          const chatwootButton = document.querySelector('.woot-widget-bubble');
          console.info(chatwootButton, !this.imageUrl, window.$chatwoot);
          if (chatwootButton && !this.imageUrl && window.$chatwoot) {
            clearInterval(checkButtonInterval);
            window.$chatwoot.toggle();
          }
        }, 100); // 每 100ms 检查一次按钮是否存在
        return;
      }
      // 触发 open 事件，传递 priceId
      this.$emit('open', this.priceId);
    },
    handleSpanClick(fileList, title) {
      console.log(fileList, title);
      this.fileList = fileList;
      this.docTitle = title;
      this.openAddPopup()
    },
  },
};
</script>

<template>
  <div class="manage-subscription">
    <div style="flex: 1">
      <h6 style="display: inline-flex; align-items: center;">
          {{ title }}
        <span v-if="isRelease" class="release-dot"></span>
      </h6>
      <p v-if="errorDesc" class="manage-subscription--description" style="color: red">
        {{ errorDesc }}
      </p>
      <p v-if="!testChat" class="manage-subscription--description">
        <span v-if="this?.merchant?.reviewStatus === 'new'">
          <span>{{this.$t("BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_CURRENT_DESCRIPTION1")}}</span><span :class="{ highlight: isHighlight(usedFileExtension) }" @click="
            isHighlight(usedFileExtension)
              ? handleSpanClick(this?.merchant?.usedFileUrlList, this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_CURRENT_DESCRIPTION1'))
              : null
            ">{{ usedFileExtension }}</span>
          <span>{{this.$t("BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_PENDING_DESCRIPTION1")}}</span><span :class="{ highlight: isHighlight(shopFileExtension) }" @click="
            isHighlight(shopFileExtension)
              ? handleSpanClick(this?.merchant?.fileUrlList || [], this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_PENDING_DESCRIPTION2'))
              : null
            ">{{ shopFileExtension }}</span>
        </span>
        <span v-if="this?.merchant?.reviewStatus === 'processing'">
          <span>{{this.$t("BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_CURRENT_DESCRIPTION1")}}</span><span :class="{ highlight: isHighlight(usedFileExtension) }" @click="
            isHighlight(usedFileExtension)
              ? handleSpanClick(this?.merchant?.usedFileUrlList, this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_CURRENT_DESCRIPTION1'))
              : null
            ">{{ usedFileExtension }}</span>
          <span>{{this.$t("BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_RELEASE_DESCRIPTION1")}}</span><span :class="{ highlight: isHighlight(approvedFileExtension) }" @click="
            isHighlight(approvedFileExtension)
              ? handleSpanClick(this?.merchant?.approvedFileUrlList, this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_RELEASE_DESCRIPTION2'))
              : null
            ">{{ approvedFileExtension }}</span>
            <span v-if="isApprovalCompare">
            <span>{{ this.$t("BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_PENDING_DESCRIPTION1") }}</span>
            <span  :class="{ highlight: isHighlight(shopFileExtension) }" @click="
              isHighlight(shopFileExtension)
                ? handleSpanClick(this?.merchant?.fileUrlList || [], this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_PENDING_DESCRIPTION2'))
                : null
              ">{{ shopFileExtension }}</span>
              </span>
        </span>
        <span v-if="this?.merchant?.reviewStatus === 'completed' && this.isCompare">
          <span>{{this.$t("BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_CURRENT_DESCRIPTION1")}}</span><span :class="{ highlight: isHighlight(usedFileExtension) }" @click="
            isHighlight(usedFileExtension)
              ? handleSpanClick(this?.merchant?.usedFileUrlList, this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_CURRENT_DESCRIPTION1'))
              : null
            ">{{ usedFileExtension }}</span>
        </span>
        <span v-if="this?.merchant?.reviewStatus === 'completed' && !this.isCompare">
          <span>{{this.$t("BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_CURRENT_DESCRIPTION1")}}</span><span :class="{ highlight: isHighlight(usedFileExtension) }" @click="
            isHighlight(usedFileExtension)
              ? handleSpanClick(this?.merchant?.usedFileUrlList, this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_CURRENT_DESCRIPTION1'))
              : null
            ">{{ usedFileExtension }}</span>
          <span>{{this.$t("BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_RELEASE_DESCRIPTION1")}}</span><span :class="{ highlight: isHighlight(shopFileExtension) }" @click="
            isHighlight(shopFileExtension)
              ? handleSpanClick(this?.merchant?.fileUrlList || [], this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TALK_REVIEW_PENDING_DESCRIPTION2'))
              : null
            ">{{ shopFileExtension }}</span>
        </span>
      </p>
      <p v-else>
        <span v-if="this?.merchant?.reviewStatus === 'processing'">
          <span>{{this.$t("BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TEST_TALK_DESCRIPTION1")}}</span><span :class="{ highlight: isHighlight(approvedFileExtension) }" @click="
            isHighlight(approvedFileExtension)
              ? handleSpanClick(this?.merchant?.approvedFileUrlList, this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TEST_TALK_DESCRIPTION1'))
              : null
            ">{{ approvedFileExtension }}</span>
        </span>
        <span v-else-if="this?.merchant?.usedFileUrlList?.length > 0">
          <span>{{this.$t("BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TEST_TALK_DESCRIPTION1")}}</span><span :class="{ highlight: isHighlight(usedFileExtension) }" @click="
            isHighlight(usedFileExtension)
              ? handleSpanClick(this?.merchant?.usedFileUrlList, this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TEST_TALK_DESCRIPTION1'))
              : null
            ">{{ usedFileExtension }}</span>
        </span>
        <span v-else>
          <span>{{ this.$t("BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TEST_TALK_DESCRIPTION2") }}</span>
        </span>
      </p>
    </div>
    <div>
      <woot-image-button :classNames="'custom-button'" v-if="imageUrl" variant="smooth" :icon="imageUrl"
        @click="handleButtonClick">
        {{ buttonLabel }}
      </woot-image-button>
      <woot-button :classNames="'custom-button'" v-else variant="smooth" :icon="buttonIcon" @click="handleButtonClick">
        {{ buttonLabel }}
      </woot-button>
    </div>
  </div>

  <woot-modal v-model:show="showAddPopup" :on-close="hideAddPopup">
    <ScriptTemplate :merchant="this.merchant" :title="this.docTitle" :file-list="this.fileList" />
  </woot-modal>
</template>

<style>
.custom-button {
  min-width: 140px;
}

.highlight {
  color: #409EFF; /* 常见的蓝色高亮 */
  text-decoration: underline; /* 下划线 */
  cursor: pointer; /* 鼠标变为手指 */
}

.release-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: red;
  border-radius: 50%;
  margin-left: 8px;
  animation: pulse 1.5s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.9;
  }
  50% {
    transform: scale(1.4);
    opacity: 0.4;
  }
  100% {
    transform: scale(1);
    opacity: 0.9;
  }
}

</style>
